import React from "react";

import METHODS from "src/app/pages/CreatorDiscoveryTool/legacy/app/helpers/methods";
import AudienceFilterLabel from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/AudienceFilterLabel/AudienceFilterLabel";
import getGenders from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/AudiencesSearch/components/filters/utils/getGenders";
import getSocialProviders from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/AudiencesSearch/components/filters/utils/getSocialProviders";
import {
  SEARCH_FILTER_CONFIGS,
  FILTER_FIELD_NAMES,
  FILTER_TYPES,
  CONTENT_KEYWORD_BLACKLIST,
  removeFilter,
  addFilter,
} from "./utils";
import {
  createArrayFilterLabel,
  createInfluencerFollowersLabel,
  createSubfieldsLabel,
  createSocialProviderLabel,
  createSingleFieldLabel,
} from "./labelCreators";

function SearchLabels({
  intl,
  baseFilters,
  changeBaseFilters,
  suggestedFilters,
  interests,
  updateBothFilters,
}) {
  const genders = getGenders(intl);
  const socialProviders = getSocialProviders(intl);

  const handleRemoveFilter = (type, tagProps) => {
    const newFilters = removeFilter(type, tagProps, baseFilters);
    changeBaseFilters(newFilters);
  };

  const handleDeactivateFilter = (type, tagProps) => {
    const newSuggestedFilters = addFilter(
      type,
      tagProps,
      suggestedFilters,
      baseFilters,
    );

    const newBaseFilters = removeFilter(type, tagProps, baseFilters);

    updateBothFilters(newBaseFilters, newSuggestedFilters);
  };

  const generateLabels = () => {
    const socialProviderIndex = 0;

    const filteredTagNames = SEARCH_FILTER_CONFIGS.filter(
      (tag) =>
        !(
          baseFilters.searchContents?.length &&
          CONTENT_KEYWORD_BLACKLIST.includes(tag.name)
        ),
    );

    const labels = filteredTagNames.map((tag, index) => {
      const { name, subfields } = tag;

      // Handle array filters
      if (Array.isArray(baseFilters[name])) {
        return baseFilters[name].map((subTag, idx) => {
          if (name === FILTER_FIELD_NAMES.INFLUENCER_FOLLOWERS) {
            return createInfluencerFollowersLabel(
              tag,
              subTag,
              idx,
              handleRemoveFilter,
              handleDeactivateFilter,
            );
          }
          return createArrayFilterLabel(
            tag,
            subTag,
            idx,
            handleRemoveFilter,
            handleDeactivateFilter,
            interests,
            socialProviders,
          );
        });
      }

      // Handle subfields
      if (
        tag.subfields &&
        (baseFilters[subfields[0]] || baseFilters[subfields[1]])
      ) {
        return createSubfieldsLabel(
          tag,
          index,
          baseFilters,
          genders,
          handleRemoveFilter,
          handleDeactivateFilter,
        );
      }

      // Handle social provider special case
      if (name === FILTER_FIELD_NAMES.INFLUENCER_SOCIAL_PROVIDER) {
        return createSocialProviderLabel(
          tag,
          baseFilters,
          socialProviders,
          handleRemoveFilter,
          handleDeactivateFilter,
        );
      }

      // Handle single field filters
      if (baseFilters[name]) {
        return createSingleFieldLabel(
          tag,
          index,
          baseFilters,
          genders,
          handleRemoveFilter,
          handleDeactivateFilter,
        );
      }

      return null;
    });

    const labelsWithSocialProvderAtFirstPlace = METHODS.changeArrayElementOrder(
      labels,
      socialProviderIndex,
      0,
    );
    return labelsWithSocialProvderAtFirstPlace;
  };

  const generateLabelsWithSocialUsername = () => {
    let socialProviderIndex = 0;

    const labels = SEARCH_FILTER_CONFIGS.map((tag, index) => {
      const { name, id, defaultMessage, field } = tag;

      const isSelectedProviders =
        name === FILTER_FIELD_NAMES.SELECTED_PROVIDERS &&
        Array.isArray(baseFilters[name]) &&
        baseFilters[name].length > 0;
      const isSocialProvider =
        name === FILTER_FIELD_NAMES.INFLUENCER_SOCIAL_PROVIDER &&
        baseFilters[name];
      const isSocialUsername =
        name === FILTER_FIELD_NAMES.INFLUENCER_SOCIAL_USERNAME;

      if (!isSelectedProviders && !isSocialProvider && !isSocialUsername) {
        return null;
      }

      let children;
      if (isSocialProvider) {
        const matchingProvider = socialProviders.find((item) => {
          socialProviderIndex = index;
          return item.value === baseFilters[name].value;
        });
        children = matchingProvider[field];
      }

      if (isSocialUsername) {
        if (Array.isArray(baseFilters[name])) {
          return baseFilters[name].map((username, idx) => (
            <AudienceFilterLabel
              key={`${id}_${idx}`}
              id={id}
              defaultMessage={defaultMessage}
              removeFilter={() =>
                handleRemoveFilter(FILTER_TYPES.SOCIAL_USERNAME, {
                  ...tag,
                  username,
                })
              }
            >
              {username}
            </AudienceFilterLabel>
          ));
        }
        children = baseFilters[name];
      }

      if (isSelectedProviders) {
        return baseFilters[name].map((subTag, idx) =>
          createArrayFilterLabel(
            tag,
            subTag,
            idx,
            handleRemoveFilter,
            handleDeactivateFilter,
            interests,
            socialProviders,
          ),
        );
      }
      return (
        <AudienceFilterLabel
          key={`${id}_${-index}`}
          id={id}
          defaultMessage={defaultMessage}
          disabled={isSocialProvider}
          removeFilter={() =>
            handleRemoveFilter(FILTER_TYPES.SINGLE_FIELD, { ...tag })
          }
        >
          {children}
        </AudienceFilterLabel>
      );
    });

    const labelsWithSocialProvderAtFirstPlace = METHODS.changeArrayElementOrder(
      labels,
      socialProviderIndex,
      0,
    );
    return labelsWithSocialProvderAtFirstPlace;
  };

  return (
    <>
      {baseFilters.influencerSocialUsername?.length
        ? generateLabelsWithSocialUsername()
        : generateLabels()}
    </>
  );
}

export default SearchLabels;
